<template>
  <div>
    <marquee-text></marquee-text>
    <b-row class="match-height" align-h="center">
      <b-col md="6">
        <tvl-chart />
      </b-col>
      <b-col md="6">
        <near-candlestick />    
      </b-col>
      <b-col md="11">
        <recap-table />    
      </b-col>
      <b-col md="5">
        <defi-traffic-chart />    
      </b-col>
      <b-col md="6">
        <new-users-chart />    
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import MarqueeText from '@/layouts/components/PricesTicker.vue'
import TvlChart from './charts/TVLChart.vue'
import NearCandlestick from './charts/NEARCandlestick.vue'
import DefiTrafficChart from './charts/DeFiTrafficChart.vue'
import NewUsersChart from './charts/NewDefiUsersChart.vue'
import RecapTable from './charts/RecapTable.vue'
export default {
  components: {
    BRow,
    BCol,

    MarqueeText,
    TvlChart,
    NearCandlestick,
    DefiTrafficChart,
    NewUsersChart,
    RecapTable,
  },
  data() {
    return {
      // ...
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
